var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-651,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "moon",
    transform: "matrix(1.52371,0,0,1,-342.147,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.656294,0,0,0.751056,224.549,74.8939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M750.861,559.977L750.861,39.462",
    style: {
      strokeWidth: "70.67px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.656294,0,0,0.751056,486.841,74.8939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M750.861,559.977L750.861,39.462",
    style: {
      strokeWidth: "70.67px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.656294,0,0,0.536127,355.899,195.249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M750.861,559.977L750.861,39.462",
    style: {
      strokeWidth: "77.9px"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.46e2450e.svg";
export { ForwardRef as ReactComponent };